"use client";

import React from "react";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function GoogleReviews() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="googlereviews" className="bg-background w-full">
      {}
      <div className="bg-secondary w-full py-[160px] px-4 md:px-8 overflow-hidden relative">
        
        {}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-[-10%] left-[-5%] w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
          <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        </div>

        <div className="max-w-5xl mx-auto relative z-10 flex flex-col items-center">
          
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => <Star key={i} data-index={i} className="w-5 h-5 fill-primary text-primary" />)}
            </div>
            <h2 className="text-primary font-sans font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight mb-6">
              Trusted by Our Community
            </h2>
            <p className="text-secondary-foreground/80 max-w-2xl mx-auto text-lg md:text-xl font-sans">
              See what our residential and commercial clients have to say about the premium facility maintenance services at Elyon Maintenance Inc.
            </p>
          </div>

          <div ref={ref} className={`w-full transition-all duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-24"}`}>
            <Card className="w-full bg-background/5 backdrop-blur-md border-border/10 rounded-xl shadow-2xl overflow-hidden">
              <CardContent className="p-8 md:p-12 flex items-center justify-center min-h-[300px]">
                <div className="w-full max-w-3xl">
                  <div className="flex flex-col md:flex-row gap-8 items-start">
                    <div className="flex-shrink-0">
                      <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-xl border border-primary/20">
                        JS
                      </div>
                    </div>
                    <div className="flex-1 space-y-4">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                        <div>
                          <h4 className="font-sans font-bold text-xl text-secondary-foreground tracking-tight">Josh Seong</h4>
                          <div className="flex gap-0.5 mt-1">
                            {[...Array(5)].map((_, i) => <Star key={i} data-index={i} className="w-4 h-4 fill-primary text-primary" />)}
                          </div>
                        </div>
                        <span className="text-sm text-secondary-foreground/60 font-sans">7 months ago</span>
                      </div>
                      <p className="text-secondary-foreground/90 text-lg md:text-xl font-sans leading-relaxed">
                        &quot;Elyon Maintenance Inc. provided exceptional service for our facility. Their team was professional, efficient, and the results exceeded our expectations. Highly recommend for any property maintenance needs!&quot;
                      </p>
                      <div className="flex items-center gap-6 pt-2">
                        <Link to="https://share.google/VXm2kQsqhSJIeMFzj" newTab className="text-sm font-semibold text-primary hover:text-primary/80 transition-colors underline decoration-primary/30 underline-offset-4">
                          View Review on Google
                        </Link>
                      </div>

                      <div className="mt-8 p-6 rounded-xl bg-white/5 border border-white/10">
                        <div className="flex items-center justify-between mb-3">
                          <h5 className="font-bold text-sm text-secondary-foreground font-sans">Response from the owner</h5>
                          <span className="text-xs text-secondary-foreground/60 font-sans">6 months ago</span>
                        </div>
                        <p className="text-base text-secondary-foreground/80 leading-relaxed italic font-sans">
                          &quot;Thank you Josh for the kind words! We take pride in our work and are glad we could help with your property maintenance. Looking forward to working with you again.&quot;
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}